module.exports = __webpack_public_path__ + "static/assets/a6ed30454b26437b4dac84c1bdecf565.gif";